/**
 * Top Program Speakers Service
 * Register Angular service for Budget Allocations
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Resource
 */

import angular from 'angular';

angular.module('flsServices').factory('ProgramTopSpeakers', ['$resource', function($resource){
    return $resource('/api/aggregate/v1/program-top-speakers');
}]);
